import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { email, phone } from '@app/dto/common.dto';
import { FOption } from '@app/shared/form-select-multi/form-select-multi.component';

export const getBusinessCard = () => {
  return new FormGroup({
    names: new FormArray([getNames()]),
    countryCode: new FormControl('', [Validators.required]),
    geographicalInformation: new FormControl(''),
    additionalIdentifiers: new FormArray([]),
    websiteURI: new FormArray([]),
    contacts: new FormArray([]),
    additionalInformation: new FormControl(''),
    isCollapsed: new FormControl(true),
  });
};

export const getNames = () => {
  return new FormGroup({
    name: new FormControl('', [Validators.required]),
    language: new FormControl('', [Validators.required]),
  });
};

export const getAdditionalIdentifiers = () => {
  return new FormGroup({
    identifierCode: new FormControl(''),
    identifierValue: new FormControl(''),
  });
};

export const getContacts = () => {
  return new FormGroup({
    type: new FormControl(''),
    name: new FormControl(''),
    phoneNumber: new FormControl('', phone),
    email: new FormControl('', email),
  });
};

export const specialIdentifiers: FOption[] = [
  { value: '01', label: '(01) - SSM Number' },
  { value: '02', label: '(02) - Sabah' },
  { value: '03', label: '(03) - Sarawak' },
  { value: '04', label: '(04) - Foreign Businesses' },
  { value: '05', label: '(05) - Testing Purposes' },
  { value: '06', label: '(06) - Others' },
  { value: '07', label: '(07) - Statutory Body' },
  { value: '08', label: '(08) - Local Authority' },
];

export const languages: FOption[] = [
  { label: 'Abkhaz', value: 'ab' },
  { label: 'Afar', value: 'aa' },
  { label: 'Afrikaans', value: 'af' },
  { label: 'Akan', value: 'ak' },
  { label: 'Albanian', value: 'sq' },
  { label: 'Amharic', value: 'am' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Aragonese', value: 'an' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Assamese', value: 'as' },
  { label: 'Avaric', value: 'av' },
  { label: 'Avestan', value: 'ae' },
  { label: 'Aymara', value: 'ay' },
  { label: 'Azerbaijani', value: 'az' },
  { label: 'Bambara', value: 'bm' },
  { label: 'Bashkir', value: 'ba' },
  { label: 'Basque', value: 'eu' },
  { label: 'Belarusian', value: 'be' },
  { label: 'Bengali', value: 'bn' },
  { label: 'Bihari', value: 'bh' },
  { label: 'Bislama', value: 'bi' },
  { label: 'Bosnian', value: 'bs' },
  { label: 'Breton', value: 'br' },
  { label: 'Bulgarian', value: 'bg' },
  { label: 'Burmese', value: 'my' },
  { label: 'Catalan; Valencian', value: 'ca' },
  { label: 'Chamorro', value: 'ch' },
  { label: 'Chechen', value: 'ce' },
  { label: 'Chichewa; Chewa; Nyanja', value: 'ny' },
  { label: 'Chinese', value: 'zh' },
  { label: 'Chuvash', value: 'cv' },
  { label: 'Cornish', value: 'kw' },
  { label: 'Corsican', value: 'co' },
  { label: 'Cree', value: 'cr' },
  { label: 'Croatian', value: 'hr' },
  { label: 'Czech', value: 'cs' },
  { label: 'Danish', value: 'da' },
  { label: 'Divehi; Dhivehi; Maldivian', value: 'dv' },
  { label: 'Dzongkha', value: 'dz' },
  { label: 'Dutch', value: 'nl' },
  { label: 'English', value: 'en' },
  { label: 'Esperanto', value: 'eo' },
  { label: 'Estonian', value: 'et' },
  { label: 'Ewe', value: 'ee' },
  { label: 'Faroese', value: 'fo' },
  { label: 'Fijian', value: 'fj' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'Fula; Fulah; Pulaar; Pular', value: 'ff' },
  { label: 'Western Frisian', value: 'fy' },
  { label: 'Galician', value: 'gl' },
  { label: 'Georgian', value: 'ka' },
  { label: 'German', value: 'de' },
  { label: 'Greek, Modern', value: 'el' },
  { label: 'Guaraní', value: 'gn' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Haitian; Haitian Creole', value: 'ht' },
  { label: 'Hausa', value: 'ha' },
  { label: 'Hebrew (modern)', value: 'he' },
  { label: 'Herero', value: 'hz' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hiri Motu', value: 'ho' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Interlingua', value: 'ia' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Interlingue', value: 'ie' },
  { label: 'Irish', value: 'ga' },
  { label: 'Igbo', value: 'ig' },
  { label: 'Inupiaq', value: 'ik' },
  { label: 'Ido', value: 'io' },
  { label: 'Icelandic', value: 'is' },
  { label: 'Italian', value: 'it' },
  { label: 'Inuktitut', value: 'iu' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Javanese', value: 'jv' },
  { label: 'Kalaallisut, Greenlandic', value: 'kl' },
  { label: 'Kannada', value: 'kn' },
  { label: 'Kanuri', value: 'kr' },
  { label: 'Kashmiri', value: 'ks' },
  { label: 'Kazakh', value: 'kk' },
  { label: 'Khmer', value: 'km' },
  { label: 'Kikuyu, Gikuyu', value: 'ki' },
  { label: 'Kinyarwanda', value: 'rw' },
  { label: 'Kirghiz, Kyrgyz', value: 'ky' },
  { label: 'Komi', value: 'kv' },
  { label: 'Kongo', value: 'kg' },
  { label: 'Korean', value: 'ko' },
  { label: 'Kurdish', value: 'ku' },
  { label: 'Kwanyama, Kuanyama', value: 'kj' },
  { label: 'Latin', value: 'la' },
  { label: 'Luxembourgish, Letzeburgesch', value: 'lb' },
  { label: 'Luganda', value: 'lg' },
  { label: 'Limburgish, Limburgan, Limburger', value: 'li' },
  { label: 'Lingala', value: 'ln' },
  { label: 'Lao', value: 'lo' },
  { label: 'Lithuanian', value: 'lt' },
  { label: 'Luba-Katanga', value: 'lu' },
  { label: 'Latvian', value: 'lv' },
  { label: 'Manx', value: 'gv' },
  { label: 'Macedonian', value: 'mk' },
  { label: 'Malagasy', value: 'mg' },
  { label: 'Malay', value: 'ms' },
  { label: 'Malayalam', value: 'ml' },
  { label: 'Maltese', value: 'mt' },
  { label: 'Māori', value: 'mi' },
  { label: 'Marathi (Marāṭhī)', value: 'mr' },
  { label: 'Marshallese', value: 'mh' },
  { label: 'Mongolian', value: 'mn' },
  { label: 'Nauru', value: 'na' },
  { label: 'Navajo, Navaho', value: 'nv' },
  { label: 'Norwegian Bokmål', value: 'nb' },
  { label: 'North Ndebele', value: 'nd' },
  { label: 'Nepali', value: 'ne' },
  { label: 'Ndonga', value: 'ng' },
  { label: 'Norwegian Nynorsk', value: 'nn' },
  { label: 'Norwegian', value: 'no' },
  { label: 'Nuosu', value: 'ii' },
  { label: 'South Ndebele', value: 'nr' },
  { label: 'Occitan', value: 'oc' },
  { label: 'Ojibwe, Ojibwa', value: 'oj' },
  {
    label: 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bu,lgarian, Old Slavonic',
    value: 'cu',
  },
  { label: 'Oromo', value: 'om' },
  { label: 'Oriya', value: 'or' },
  { label: 'Ossetian, Ossetic', value: 'os' },
  { label: 'Panjabi, Punjabi', value: 'pa' },
  { label: 'Pāli', value: 'pi' },
  { label: 'Persian', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Pashto, Pushto', value: 'ps' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Quechua', value: 'qu' },
  { label: 'Romansh', value: 'rm' },
  { label: 'Kirundi', value: 'rn' },
  { label: 'Romanian, Moldavian, Moldovan', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Sanskrit (Saṁskṛta)', value: 'sa' },
  { label: 'Sardinian', value: 'sc' },
  { label: 'Sindhi', value: 'sd' },
  { label: 'Northern Sami', value: 'se' },
  { label: 'Samoan', value: 'sm' },
  { label: 'Sango', value: 'sg' },
  { label: 'Serbian', value: 'sr' },
  { label: 'Scottish Gaelic; Gaelic', value: 'gd' },
  { label: 'Shona', value: 'sn' },
  { label: 'Sinhala, Sinhalese', value: 'si' },
  { label: 'Slovak', value: 'sk' },
  { label: 'Slovene', value: 'sl' },
  { label: 'Somali', value: 'so' },
  { label: 'Southern Sotho', value: 'st' },
  { label: 'Spanish; Castilian', value: 'es' },
  { label: 'Sundanese', value: 'su' },
  { label: 'Swahili', value: 'sw' },
  { label: 'Swati', value: 'ss' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Telugu', value: 'te' },
  { label: 'Tajik', value: 'tg' },
  { label: 'Thai', value: 'th' },
  { label: 'Tigrinya', value: 'ti' },
  { label: 'Tibetan Standard, Tibetan, Central', value: 'bo' },
  { label: 'Turkmen', value: 'tk' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'Tswana', value: 'tn' },
  { label: 'Tonga (Tonga Islands)', value: 'to' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Tsonga', value: 'ts' },
  { label: 'Tatar', value: 'tt' },
  { label: 'Twi', value: 'tw' },
  { label: 'Tahitian', value: 'ty' },
  { label: 'Uighur, Uyghur', value: 'ug' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Uzbek', value: 'uz' },
  { label: 'Venda', value: 've' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Volapük', value: 'vo' },
  { label: 'Walloon', value: 'wa' },
  { label: 'Welsh', value: 'cy' },
  { label: 'Wolof', value: 'wo' },
  { label: 'Western Frisian', value: 'fy' },
  { label: 'Xhosa', value: 'xh' },
  { label: 'Yiddish', value: 'yi' },
  { label: 'Yoruba', value: 'yo' },
  { label: 'Zhuang, Chuang', value: 'za' },
];

export const countries: FOption[] = [
  {
    value: 'AD',
    label: 'Andorra',
  },
  {
    value: 'AE',
    label: 'United Arab Emirates',
  },
  {
    value: 'AF',
    label: 'Afghanistan',
  },
  {
    value: 'AG',
    label: 'Antigua and Barbuda',
  },
  {
    value: 'AI',
    label: 'Anguilla',
  },
  {
    value: 'AL',
    label: 'Albania',
  },
  {
    value: 'AM',
    label: 'Armenia',
  },
  {
    value: 'AO',
    label: 'Angola',
  },
  {
    value: 'AQ',
    label: 'Antarctica',
  },
  {
    value: 'AR',
    label: 'Argentina',
  },
  {
    value: 'AS',
    label: 'American Samoa',
  },
  {
    value: 'AT',
    label: 'Austria',
  },
  {
    value: 'AU',
    label: 'Australia',
  },
  {
    value: 'AW',
    label: 'Aruba',
  },
  {
    value: 'AX',
    label: 'Åland Islands',
  },
  {
    value: 'AZ',
    label: 'Azerbaijan',
  },
  {
    value: 'BA',
    label: 'Bosnia and Herzegovina',
  },
  {
    value: 'BB',
    label: 'Barbados',
  },
  {
    value: 'BD',
    label: 'Bangladesh',
  },
  {
    value: 'BE',
    label: 'Belgium',
  },
  {
    value: 'BF',
    label: 'Burkina Faso',
  },
  {
    value: 'BG',
    label: 'Bulgaria',
  },
  {
    value: 'BH',
    label: 'Bahrain',
  },
  {
    value: 'BI',
    label: 'Burundi',
  },
  {
    value: 'BJ',
    label: 'Benin',
  },
  {
    value: 'BL',
    label: 'Saint Barthélemy',
  },
  {
    value: 'BM',
    label: 'Bermuda',
  },
  {
    value: 'BN',
    label: 'Brunei Darussalam',
  },
  {
    value: 'BO',
    label: 'Bolivia, Plurinational State of',
  },
  {
    value: 'BQ',
    label: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    value: 'BR',
    label: 'Brazil',
  },
  {
    value: 'BS',
    label: 'Bahamas',
  },
  {
    value: 'BT',
    label: 'Bhutan',
  },
  {
    value: 'BV',
    label: 'Bouvet Island',
  },
  {
    value: 'BW',
    label: 'Botswana',
  },
  {
    value: 'BY',
    label: 'Belarus',
  },
  {
    value: 'BZ',
    label: 'Belize',
  },
  {
    value: 'CA',
    label: 'Canada',
  },
  {
    value: 'CC',
    label: 'Cocos (Keeling) Islands',
  },
  {
    value: 'CD',
    label: 'Congo, the Democratic Republic of the',
  },
  {
    value: 'CF',
    label: 'Central African Republic',
  },
  {
    value: 'CG',
    label: 'Congo',
  },
  {
    value: 'CH',
    label: 'Switzerland',
  },
  {
    value: 'CI',
    label: "Côte d'Ivoire",
  },
  {
    value: 'CK',
    label: 'Cook Islands',
  },
  {
    value: 'CL',
    label: 'Chile',
  },
  {
    value: 'CM',
    label: 'Cameroon',
  },
  {
    value: 'CN',
    label: 'China',
  },
  {
    value: 'CO',
    label: 'Colombia',
  },
  {
    value: 'CR',
    label: 'Costa Rica',
  },
  {
    value: 'CU',
    label: 'Cuba',
  },
  {
    value: 'CV',
    label: 'Cabo Verde',
  },
  {
    value: 'CW',
    label: 'Curaçao',
  },
  {
    value: 'CX',
    label: 'Christmas Island',
  },
  {
    value: 'CY',
    label: 'Cyprus',
  },
  {
    value: 'CZ',
    label: 'Czechia',
  },
  {
    value: 'DE',
    label: 'Germany',
  },
  {
    value: 'DJ',
    label: 'Djibouti',
  },
  {
    value: 'DK',
    label: 'Denmark',
  },
  {
    value: 'DM',
    label: 'Dominica',
  },
  {
    value: 'DO',
    label: 'Dominican Republic',
  },
  {
    value: 'DZ',
    label: 'Algeria',
  },
  {
    value: 'EC',
    label: 'Ecuador',
  },
  {
    value: 'EE',
    label: 'Estonia',
  },
  {
    value: 'EG',
    label: 'Egypt',
  },
  {
    value: 'EH',
    label: 'Western Sahara',
  },
  {
    value: 'ER',
    label: 'Eritrea',
  },
  {
    value: 'ES',
    label: 'Spain',
  },
  {
    value: 'ET',
    label: 'Ethiopia',
  },
  {
    value: 'FI',
    label: 'Finland',
  },
  {
    value: 'FJ',
    label: 'Fiji',
  },
  {
    value: 'FK',
    label: 'Falkland Islands (Malvinas)',
  },
  {
    value: 'FM',
    label: 'Micronesia, Federated States of',
  },
  {
    value: 'FO',
    label: 'Faroe Islands',
  },
  {
    value: 'FR',
    label: 'France',
  },
  {
    value: 'GA',
    label: 'Gabon',
  },
  {
    value: 'GB',
    label: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    value: 'GD',
    label: 'Grenada',
  },
  {
    value: 'GE',
    label: 'Georgia',
  },
  {
    value: 'GF',
    label: 'French Guiana',
  },
  {
    value: 'GG',
    label: 'Guernsey',
  },
  {
    value: 'GH',
    label: 'Ghana',
  },
  {
    value: 'GI',
    label: 'Gibraltar',
  },
  {
    value: 'GL',
    label: 'Greenland',
  },
  {
    value: 'GM',
    label: 'Gambia',
  },
  {
    value: 'GN',
    label: 'Guinea',
  },
  {
    value: 'GP',
    label: 'Guadeloupe',
  },
  {
    value: 'GQ',
    label: 'Equatorial Guinea',
  },
  {
    value: 'GR',
    label: 'Greece',
  },
  {
    value: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
  },
  {
    value: 'GT',
    label: 'Guatemala',
  },
  {
    value: 'GU',
    label: 'Guam',
  },
  {
    value: 'GW',
    label: 'Guinea-Bissau',
  },
  {
    value: 'GY',
    label: 'Guyana',
  },
  {
    value: 'HK',
    label: 'Hong Kong',
  },
  {
    value: 'HM',
    label: 'Heard Island and McDonald Islands',
  },
  {
    value: 'HN',
    label: 'Honduras',
  },
  {
    value: 'HR',
    label: 'Croatia',
  },
  {
    value: 'HT',
    label: 'Haiti',
  },
  {
    value: 'HU',
    label: 'Hungary',
  },
  {
    value: 'ID',
    label: 'Indonesia',
  },
  {
    value: 'IE',
    label: 'Ireland',
  },
  {
    value: 'IL',
    label: 'Israel',
  },
  {
    value: 'IM',
    label: 'Isle of Man',
  },
  {
    value: 'IN',
    label: 'India',
  },
  {
    value: 'IO',
    label: 'British Indian Ocean Territory',
  },
  {
    value: 'IQ',
    label: 'Iraq',
  },
  {
    value: 'IR',
    label: 'Iran, Islamic Republic of',
  },
  {
    value: 'IS',
    label: 'Iceland',
  },
  {
    value: 'IT',
    label: 'Italy',
  },
  {
    value: 'JE',
    label: 'Jersey',
  },
  {
    value: 'JM',
    label: 'Jamaica',
  },
  {
    value: 'JO',
    label: 'Jordan',
  },
  {
    value: 'JP',
    label: 'Japan',
  },
  {
    value: 'KE',
    label: 'Kenya',
  },
  {
    value: 'KG',
    label: 'Kyrgyzstan',
  },
  {
    value: 'KH',
    label: 'Cambodia',
  },
  {
    value: 'KI',
    label: 'Kiribati',
  },
  {
    value: 'KM',
    label: 'Comoros',
  },
  {
    value: 'KN',
    label: 'Saint Kitts and Nevis',
  },
  {
    value: 'KP',
    label: "Korea, Democratic People's Republic of",
  },
  {
    value: 'KR',
    label: 'Korea, Republic of',
  },
  {
    value: 'KW',
    label: 'Kuwait',
  },
  {
    value: 'KY',
    label: 'Cayman Islands',
  },
  {
    value: 'KZ',
    label: 'Kazakhstan',
  },
  {
    value: 'LA',
    label: "Lao People's Democratic Republic",
  },
  {
    value: 'LB',
    label: 'Lebanon',
  },
  {
    value: 'LC',
    label: 'Saint Lucia',
  },
  {
    value: 'LI',
    label: 'Liechtenstein',
  },
  {
    value: 'LK',
    label: 'Sri Lanka',
  },
  {
    value: 'LR',
    label: 'Liberia',
  },
  {
    value: 'LS',
    label: 'Lesotho',
  },
  {
    value: 'LT',
    label: 'Lithuania',
  },
  {
    value: 'LU',
    label: 'Luxembourg',
  },
  {
    value: 'LV',
    label: 'Latvia',
  },
  {
    value: 'LY',
    label: 'Libya',
  },
  {
    value: 'MA',
    label: 'Morocco',
  },
  {
    value: 'MC',
    label: 'Monaco',
  },
  {
    value: 'MD',
    label: 'Moldova, Republic of',
  },
  {
    value: 'ME',
    label: 'Montenegro',
  },
  {
    value: 'MF',
    label: 'Saint Martin (French part)',
  },
  {
    value: 'MG',
    label: 'Madagascar',
  },
  {
    value: 'MH',
    label: 'Marshall Islands',
  },
  {
    value: 'MK',
    label: 'Macedonia, the former Yugoslav Republic of',
  },
  {
    value: 'ML',
    label: 'Mali',
  },
  {
    value: 'MM',
    label: 'Myanmar',
  },
  {
    value: 'MN',
    label: 'Mongolia',
  },
  {
    value: 'MO',
    label: 'Macao',
  },
  {
    value: 'MP',
    label: 'Northern Mariana Islands',
  },
  {
    value: 'MQ',
    label: 'Martinique',
  },
  {
    value: 'MR',
    label: 'Mauritania',
  },
  {
    value: 'MS',
    label: 'Montserrat',
  },
  {
    value: 'MT',
    label: 'Malta',
  },
  {
    value: 'MU',
    label: 'Mauritius',
  },
  {
    value: 'MV',
    label: 'Maldives',
  },
  {
    value: 'MW',
    label: 'Malawi',
  },
  {
    value: 'MX',
    label: 'Mexico',
  },
  {
    value: 'MY',
    label: 'Malaysia',
  },
  {
    value: 'MZ',
    label: 'Mozambique',
  },
  {
    value: 'NA',
    label: 'Namibia',
  },
  {
    value: 'NC',
    label: 'New Caledonia',
  },
  {
    value: 'NE',
    label: 'Niger',
  },
  {
    value: 'NF',
    label: 'Norfolk Island',
  },
  {
    value: 'NG',
    label: 'Nigeria',
  },
  {
    value: 'NI',
    label: 'Nicaragua',
  },
  {
    value: 'NL',
    label: 'Netherlands',
  },
  {
    value: 'NO',
    label: 'Norway',
  },
  {
    value: 'NP',
    label: 'Nepal',
  },
  {
    value: 'NR',
    label: 'Nauru',
  },
  {
    value: 'NU',
    label: 'Niue',
  },
  {
    value: 'NZ',
    label: 'New Zealand',
  },
  {
    value: 'OM',
    label: 'Oman',
  },
  {
    value: 'PA',
    label: 'Panama',
  },
  {
    value: 'PE',
    label: 'Peru',
  },
  {
    value: 'PF',
    label: 'French Polynesia',
  },
  {
    value: 'PG',
    label: 'Papua New Guinea',
  },
  {
    value: 'PH',
    label: 'Philippines',
  },
  {
    value: 'PK',
    label: 'Pakistan',
  },
  {
    value: 'PL',
    label: 'Poland',
  },
  {
    value: 'PM',
    label: 'Saint Pierre and Miquelon',
  },
  {
    value: 'PN',
    label: 'Pitcairn',
  },
  {
    value: 'PR',
    label: 'Puerto Rico',
  },
  {
    value: 'PS',
    label: 'Palestine, State of',
  },
  {
    value: 'PT',
    label: 'Portugal',
  },
  {
    value: 'PW',
    label: 'Palau',
  },
  {
    value: 'PY',
    label: 'Paraguay',
  },
  {
    value: 'QA',
    label: 'Qatar',
  },
  {
    value: 'RE',
    label: 'Réunion',
  },
  {
    value: 'RO',
    label: 'Romania',
  },
  {
    value: 'RS',
    label: 'Serbia',
  },
  {
    value: 'RU',
    label: 'Russian Federation',
  },
  {
    value: 'RW',
    label: 'Rwanda',
  },
  {
    value: 'SA',
    label: 'Saudi Arabia',
  },
  {
    value: 'SB',
    label: 'Solomon Islands',
  },
  {
    value: 'SC',
    label: 'Seychelles',
  },
  {
    value: 'SD',
    label: 'Sudan',
  },
  {
    value: 'SE',
    label: 'Sweden',
  },
  {
    value: 'SG',
    label: 'Singapore',
  },
  {
    value: 'SH',
    label: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    value: 'SI',
    label: 'Slovenia',
  },
  {
    value: 'SJ',
    label: 'Svalbard and Jan Mayen',
  },
  {
    value: 'SK',
    label: 'Slovakia',
  },
  {
    value: 'SL',
    label: 'Sierra Leone',
  },
  {
    value: 'SM',
    label: 'San Marino',
  },
  {
    value: 'SN',
    label: 'Senegal',
  },
  {
    value: 'SO',
    label: 'Somalia',
  },
  {
    value: 'SR',
    label: 'Suriname',
  },
  {
    value: 'SS',
    label: 'South Sudan',
  },
  {
    value: 'ST',
    label: 'Sao Tome and Principe',
  },
  {
    value: 'SV',
    label: 'El Salvador',
  },
  {
    value: 'SX',
    label: 'Sint Maarten (Dutch part)',
  },
  {
    value: 'SY',
    label: 'Syrian Arab Republic',
  },
  {
    value: 'SZ',
    label: 'Swaziland',
  },
  {
    value: 'TC',
    label: 'Turks and Caicos Islands',
  },
  {
    value: 'TD',
    label: 'Chad',
  },
  {
    value: 'TF',
    label: 'French Southern Territories',
  },
  {
    value: 'TG',
    label: 'Togo',
  },
  {
    value: 'TH',
    label: 'Thailand',
  },
  {
    value: 'TJ',
    label: 'Tajikistan',
  },
  {
    value: 'TK',
    label: 'Tokelau',
  },
  {
    value: 'TL',
    label: 'Timor-Leste',
  },
  {
    value: 'TM',
    label: 'Turkmenistan',
  },
  {
    value: 'TN',
    label: 'Tunisia',
  },
  {
    value: 'TO',
    label: 'Tonga',
  },
  {
    value: 'TR',
    label: 'Turkey',
  },
  {
    value: 'TT',
    label: 'Trinidad and Tobago',
  },
  {
    value: 'TV',
    label: 'Tuvalu',
  },
  {
    value: 'TW',
    label: 'Taiwan, Province of China',
  },
  {
    value: 'TZ',
    label: 'Tanzania, United Republic of',
  },
  {
    value: 'UA',
    label: 'Ukraine',
  },
  {
    value: 'UG',
    label: 'Uganda',
  },
  {
    value: 'UM',
    label: 'United States Minor Outlying Islands',
  },
  {
    value: 'US',
    label: 'United States of America',
  },
  {
    value: 'UY',
    label: 'Uruguay',
  },
  {
    value: 'UZ',
    label: 'Uzbekistan',
  },
  {
    value: 'VA',
    label: 'Holy See',
  },
  {
    value: 'VC',
    label: 'Saint Vincent and the Grenadines',
  },
  {
    value: 'VE',
    label: 'Venezuela, Bolivarian Republic of',
  },
  {
    value: 'VG',
    label: 'Virgin Islands, British',
  },
  {
    value: 'VI',
    label: 'Virgin Islands, U.S.',
  },
  {
    value: 'VN',
    label: 'Viet Nam',
  },
  {
    value: 'VU',
    label: 'Vanuatu',
  },
  {
    value: 'WF',
    label: 'Wallis and Futuna',
  },
  {
    value: 'WS',
    label: 'Samoa',
  },
  {
    value: 'YE',
    label: 'Yemen',
  },
  {
    value: 'YT',
    label: 'Mayotte',
  },
  {
    value: 'ZA',
    label: 'South Africa',
  },
  {
    value: 'ZM',
    label: 'Zambia',
  },
  {
    value: 'ZW',
    label: 'Zimbabwe',
  },
  {
    value: '1A',
    label: 'Kosovo',
  },
  {
    value: 'XI',
    label: 'United Kingdom (Northern Ireland)',
  },
];
export const additionalIdentifiersOptions: FOption[] = [
  { value: '0088', label: 'GLN (0088) - GS1' },
  { value: '0060', label: 'DUNS (0060) - Dun and Bradstreet Ltd' },
  {
    value: '9918',
    label:
      'IBAN (9918) - S.W.I.F.T. Society for Worldwide Interbank Financial Telecommunications s.c.',
  },
  { value: '9901', label: 'DK:CPR (9901) - Danish Ministry of the Interior and Health' },
  { value: '9902', label: 'DK:CVR (9902) - The Danish Commerce and Companies Agency' },
  { value: '0096', label: 'DK:P (0096) - The Danish Commerce and Companies Agency' },
  {
    value: '9904',
    label: 'DK:SE (9904) - Danish Ministry of Taxation, Central Customs and Tax Administration',
  },
  { value: '9905', label: 'DK:VANS (9905) - Danish VANS providers' },
  { value: '9906', label: 'IT:VAT (9906) - Ufficio responsabile gestione partite IVA' },
  { value: '9907', label: 'IT:CF (9907) - TAX Authority' },
  { value: '0097', label: 'IT:FTI (0097) - Ediforum Italia' },
  { value: '0135', label: 'IT:SIA (0135) - Società Interbancaria per l Automazione' },
  { value: '0142', label: 'IT:SECETI (0142) - Servizi Centralizzati SECETI' },
  { value: '9908', label: 'NO:ORGNR (9908) - Enhetsregisteret ved Brønnøysundregistrene' },
  { value: '9909', label: 'NO:VAT (9909) - Enhetsregisteret ved Brønnøysundregistrene' },
  { value: '9910', label: 'HU:VAT (9910) - Hungarian Tax Board' },
  { value: '0007', label: 'SE:ORGNR (0007) - The Swedish National Tax Board' },
  { value: '0037', label: 'FI:OVT (0037) - Finnish tax board' },
  { value: '9912', label: 'EU:VAT (9912) - National ministries of Economy' },
  { value: '9913', label: 'EU:REID (9913) - Business Registers Network' },
  {
    value: '0002',
    label: 'FR:SIRENE (0002) - INSEE: National Institute for statistics and Economic studies',
  },
  { value: '9914', label: 'AT:VAT (9914) - Österreichische Umsatzsteuer-Identifikationsnummer' },
  {
    value: '9915',
    label: 'AT:GOV (9915) - Österreichisches Verwaltungs bzw. Organisationskennzeichen',
  },
  { value: '9917', label: 'IS:KT (9917) - Icelandic National Registry' },
  {
    value: '0106',
    label: 'NL:KVK (0106) - Vereniging van Kamers van Koophandel en Fabrieken in Nederland',
  },
  { value: '9944', label: 'NL:VAT (9944) - Netherlands VAT number' },
  { value: '9922', label: 'AD:VAT (9922) - Andorra VAT number' },
  { value: '9923', label: 'AL:VAT (9923) - Albania VAT number' },
  { value: '9919', label: 'AT:KUR (9919) - Kennziffer des Unternehmensregisters' },
  { value: '9924', label: 'BA:VAT (9924) - Bosnia and Herzegovina VAT number' },
  { value: '9925', label: 'BE:VAT (9925) - Belgium VAT number' },
  { value: '9926', label: 'BG:VAT (9926) - Bulgaria VAT number' },
  { value: '9927', label: 'CH:VAT (9927) - Switzerland VAT number' },
  { value: '9928', label: 'CY:VAT (9928) - Cyprus VAT number' },
  { value: '9929', label: 'CZ:VAT (9929) - Czech Republic VAT number' },
  { value: '9930', label: 'DE:VAT (9930) - Germany VAT number' },
  { value: '9931', label: 'EE:VAT (9931) - Estonia VAT number' },
  { value: '9920', label: 'ES:VAT (9920) - Agencia Española de Administración Tributaria' },
  { value: '9939', label: 'LV:VAT (9939) - Latvia VAT number' },
  { value: '9932', label: 'GB:VAT (9932) - United Kingdom VAT number' },
  { value: '9933', label: 'GR:VAT (9933) - Greece VAT number' },
  { value: '9934', label: 'HR:VAT (9934) - Croatia VAT number' },
  { value: '9935', label: 'IE:VAT (9935) - Ireland VAT number' },
  { value: '9921', label: 'IT:IPA (9921) - Indice delle Pubbliche Amministrazioni' },
  { value: '9937', label: 'LT:VAT (9937) - Lithuania VAT number' },
  { value: '9938', label: 'LU:VAT (9938) - Luxemburg VAT number' },
  { value: '9940', label: 'MC:VAT (9940) - Monaco VAT number' },
  { value: '9941', label: 'ME:VAT (9941) - Montenegro VAT number' },
  { value: '9942', label: 'MK:VAT (9942) - Macedonia, the former Yugoslav Republic of VAT number' },
  { value: '9943', label: 'MT:VAT (9943) - Malta VAT number' },
  { value: '9954', label: 'NL:OIN (9954) - Dutch OverheidsIdentificatieNummer' },
  { value: '9945', label: 'PL:VAT (9945) - Poland VAT number' },
  { value: '9946', label: 'PT:VAT (9946) - Portugal VAT number' },
  { value: '9947', label: 'RO:VAT (9947) - Romania VAT number' },
  { value: '9948', label: 'RS:VAT (9948) - Serbia VAT number' },
  { value: '9949', label: 'SI:VAT (9949) - Slovenia VAT number' },
  { value: '9950', label: 'SK:VAT (9950) - Slovakia VAT number' },
  { value: '9951', label: 'SM:VAT (9951) - San Marino VAT number' },
  { value: '9952', label: 'TR:VAT (9952) - Turkey VAT number' },
  { value: '0009', label: 'FR:SIRET (0009) - DU PONT DE NEMOURS' },
  { value: '9956', label: 'BE:CBE (9956) - Belgian Crossroad Bank of Enterprises' },
  { value: '9955', label: 'SE:VAT (9955) - Swedish VAT number' },
  { value: '9936', label: 'LI:VAT (9936) - Liechtenstein VAT number' },
  { value: '9957', label: 'FR:VAT (9957) - France VAT number' },
  { value: '0191', label: 'EE:CC (0191) - Estonia company code' },
  { value: '9958', label: 'DE:LID (9958) - German Leitweg ID' },
  { value: '0184', label: 'DK:DIGST (0184) - DIGSTORG' },
  { value: '0192', label: 'NO:ORG (0192) - The Brønnøysund Register Centre' },
  { value: '0195', label: 'SG:UEN (0195) - Singapore Nationwide elnvoice Framework' },
  { value: '0190', label: 'NL:OINO (0190) - Organisatie Indentificatie Nummer' },
  { value: '0193', label: 'UBLBE (0193) - UBL.BE' },
  { value: '0196', label: 'IS:KTNR (0196) - Icelandic National Registry' },
  { value: '0130', label: 'EU:NAL (0130) - Directorates of the European Commission' },
  { value: '0183', label: 'CH:UIDB (0183) - Swiss Unique Business Identification Number' },
  { value: '0198', label: 'DK:ERST (0198) - The Danish Business Authority' },
  { value: '0199', label: 'LEI (0199) - Legal Entity Identifier' },
  { value: '0200', label: 'LT:LEC (0200) - State Enterprise Centre of Registers' },
  { value: '0201', label: 'IT:CUUO (0201) - Codice Univoco Unità Organizzativa iPA' },
  { value: '9917', label: 'IS:KT (9917) - Icelandic National Registry' },
  { value: '9954', label: "NL:OIN (9954) - Dutch Originator's Identification Number" },
  {
    value: '0208',
    label: 'BE:EN (0208) - Numero entreprise / ondernemingsnummer / Unternehmensnummer',
  },
  { value: '0209', label: 'GS1 (0209) - GS1 identification keys' },
  { value: '0210', label: 'IT:CFI (0210) - CODICE FISCALE' },
  { value: '0211', label: 'IT:IVA (0211) - PARTITA IVA' },
  { value: '0212', label: 'FI:ORG (0212) - Finnish Organization Identifier' },
  { value: '0213', label: 'FI:VAT (0213) - Finnish Organization Value Add Tax Identifier' },
  {
    value: '0188',
    label: 'JP:SST (0188) - Corporate Number of The Social Security and Tax Number System',
  },
  { value: '0215', label: 'FI:NSI (0215) - Net service ID' },
  { value: '0216', label: 'FI:OVT2 (0216) - OVTcode' },
  { value: '9959', label: 'US:EIN (9959) - US Employer ID Number' },
  { value: '0221', label: 'JP:IIN (0221) - The registered number of the qualified invoice issuer' },
  { value: '0230', label: 'MY:EIF (0230) - National e-Invoicing Framework' },
  { value: '0151', label: 'AU:ABN (0151) - Australian Business Number (ABN) Scheme' },
  { value: '9953', label: 'VA:VAT (9953) - Holy See (Vatican City State) VAT number' },
  { value: '0204', label: 'DE:LWID (0204) - Koordinierungsstelle für IT-Standards (KoSIT)' },
];
export const documentTypes: FOption[] = [
  { value: '272', label: 'MY PINT Invoice v1.0 * (wildcard)[272]' },
  { value: '273', label: 'MY PINT CreditNote v1.0 * (wildcard)[273]' },
  { value: '274', label: 'MY PINT Self - Billing Invoice v1.0 * (wildcard)[274]' },
  { value: '275', label: 'MY PINT Self - Billing CreditNote v1.0 * (wildcard)[275]' },
];
